import { AggrementClientApi, Agreement } from "./aggrementClient.types";

export const aggrementClientFormatter = (data: Agreement): AggrementClientApi => ({
    id: data.id,
    name: data.name,
    agreementText: data.agreement_text,
    required: data.is_required,
    error: false,
});